module.exports = __webpack_public_path__ + "static/media/info.d3d485c3.svg";